import { Component, OnInit, Input, EventEmitter, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { departmentsOptionsConstant, currencyOptionsConstant, organisationType, organisationSubType } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { CommonService } from '../../../../services/common.service';
import { MessageBoxComponent } from '../../../../common/message-box/message-box.component';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import * as $ from 'jquery';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-eap-study-team-organization-view-modal',
  templateUrl: './eap-study-team-organization-view-modal.component.html',
  styleUrls: ['./eap-study-team-organization-view-modal.component.scss']
})
export class EapStudyTeamOrganizationViewModalComponent implements OnInit {

  formFields;
  departments = departmentsOptionsConstant;
  organisationType: any[];
  organisationSubType:any[];
  studyTeamOrganizationForm: UntypedFormGroup;
  ApplicationID: any;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();

  currencyOptions = currencyOptionsConstant;
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  constructor(
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    public modalRef: NgbActiveModal,
    public datashareService: IstDataShareService,
    public commonService: CommonService,

  ) {
  }

  ngOnInit() {
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    //const reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
    this.studyTeamOrganizationForm = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      APPLICATION_ID: new UntypedFormControl(""),
      NAME: new UntypedFormControl(""),
      TYPE: new UntypedFormControl(null),
      CITY: new UntypedFormControl(""),
      COUNTRY: new UntypedFormControl(""),
      PROVINCE: new UntypedFormControl(""),
      SUB_TYPE: new UntypedFormControl(null),
      WEB_SITE: new UntypedFormControl("", [Validators.required]),
      ADDRESS: new UntypedFormControl(""),
      POSTAL_CODE: new UntypedFormControl(""),
      EMAIL: new UntypedFormControl("", Validators.email),
      PHONE: new UntypedFormControl("", [Validators.pattern("^[0-9]*$"),
        Validators.maxLength(15)]),

      PHONE_EXT: new UntypedFormControl("", [Validators.pattern("^[0-9]*$"), Validators.maxLength(5)]),
      OTHER_PHONE: new UntypedFormControl("", [Validators.pattern("^[0-9]*$"),
       Validators.maxLength(15)]),

      OTHER_PHONE_EXT: new UntypedFormControl("", [Validators.pattern("^[0-9]*$"), Validators.maxLength(5)]),
      FAX: new UntypedFormControl(""),
      FAX_EXT: new UntypedFormControl("", [Validators.pattern("^[0-9]*$"), Validators.maxLength(5)]),
      NOTES: new UntypedFormControl(""),
    });
    this.getMasterData();
    if (this.heading == "Edit" || this.heading == "View") {
      this.getOrganizationData();
    }
    //if (this.heading === 'Add') { //Add mode 
    //  this.content.id = this.commonService.getUniqueId();
    //}
  }
  getMasterData() {
    this.organisationType=[];
    this.organisationSubType = [];
    this.summaryService.getSummaryData('api/EAPOrganization/GetMasterData?ApplicationID=' + this.ApplicationID + "&RecordID=" + this.content.id).subscribe(summary => {
      this.organisationType = summary["MasterData1"];
      this.organisationSubType = summary["MasterData2"];
      });
  }
  getOrganizationData() {
    this.summaryService.getSummaryData('api/EAPOrganization/Edit?RecordID=' + this.content.id).subscribe(summary => {
      debugger;
      this.studyTeamOrganizationForm.patchValue({
        ID: summary["ID"],
        APPLICATION_ID: summary["APPLICATION_ID"],
        NAME: summary["NAME"],
        TYPE: summary["TYPE"],
        CITY: summary["CITY"],
        PROVINCE: summary["PROVINCE"],
        COUNTRY: summary["COUNTRY"],
        SUB_TYPE: summary["SUB_TYPE"],
        WEB_SITE: summary["WEB_SITE"],
        ADDRESS: summary["ADDRESS"],
        POSTAL_CODE: summary["POSTAL_CODE"],
        EMAIL: summary["EMAIL"],
        PHONE: summary["PHONE"],
        PHONE_EXT: summary["PHONE_EXT"],
        OTHER_PHONE: summary["OTHER_PHONE"],
        OTHER_PHONE_EXT: summary["OTHER_PHONE_EXT"],
        FAX: summary["FAX"],
        FAX_EXT: summary["FAX_EXT"],
        NOTES: summary["NOTES"],
      });
      debugger;;
      if (this.heading == "View") {
        this.studyTeamOrganizationForm.disable();
      }

    });
  }
  PostalCodekeyUP(value: string) {
    if (value.length == parseInt("5")) {
      this.commonService.getCity(value).subscribe(x => {
        if (x.Status) {
          this.studyTeamOrganizationForm.controls["CITY"].setValue(x.Data.City);
          this.studyTeamOrganizationForm.controls["PROVINCE"].setValue(x.Data.StateFullName);
          this.studyTeamOrganizationForm.controls["COUNTRY"].setValue(x.Data.Country);
        }
      });
    } else {
      this.studyTeamOrganizationForm.controls["CITY"].setValue("");
      this.studyTeamOrganizationForm.controls["PROVINCE"].setValue("");
      this.studyTeamOrganizationForm.controls["COUNTRY"].setValue("");
    }
  }
  SaveISTOrganization() {
    if (this.validateControls() && this.extendedForm.validateControls()) {
      var formData = this.studyTeamOrganizationForm.value;

      formData.APPLICATION_ID = this.ApplicationID;
      formData.PHONE_EXT = parseInt(formData.PHONE_EXT);
      formData.OTHER_PHONE_EXT = parseInt(formData.OTHER_PHONE_EXT);
      formData.FAX_EXT = parseInt(formData.FAX_EXT);
      formData.RECORD_STATE = parseInt("0");
      formData.CREATED_DATE = new Date();
      formData.LAST_UPDATED_DATE = new Date();
      if (this.heading == "Add") {
        //formData["ID"] = this.content.id;
        this.summaryService.Insert('api/EAPOrganization/Insert', formData).subscribe(summary => {
          this.extendedForm.saveControls(summary.TransactionCode).subscribe(result1 => {
           // this.modalService.show(MessageBoxComponent, { data: { heading: 'Insert', content: { heading: '', description: 'Data has been inserted successfully.' } } });
             
             this.modalRef.close();
          });
          
        });
      }
      else {
        this.summaryService.Insert('api/EAPOrganization/Update', formData).subscribe(summary => {
          this.extendedForm.saveControls(summary.TransactionCode).subscribe(result1 => {
           // this.modalService.show(MessageBoxComponent, { data: { heading: 'Update', content: { heading: '', description: 'Data has been inserted successfully.' } } });
            
            this.modalRef.close();
          });
        });
      }

     
    }
  }

  CancelPopUp() {
    
    this.modalRef.close();
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.studyTeamOrganizationForm.value;
    if (formData.NAME === null || formData.NAME === "") {
      $("#NAME").addClass("ng-touched ng-invalid validate-error");
      $("#NAME").removeClass("ng-untouched ng-valid");
      message += "Please enter Name.<br/>";
      isValid = false;
    } else {
      $("#NAME").addClass("ng-untouched ng-valid");
      $("#NAME").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.WEB_SITE === null || formData.WEB_SITE === "") {
      $("#WEB_SITE").addClass("ng-touched ng-invalid validate-error");
      $("#WEB_SITE").removeClass("ng-untouched ng-valid");
      message += "Please enter Web-Site.<br/>";
      isValid = false;
    } else {
      const website = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
      if (formData.EMAIL.match(website)) {
        $("#WEB_SITE").addClass("ng-untouched ng-valid");
        $("#WEB_SITE").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#WEB_SITE").addClass("ng-touched ng-invalid validate-error");
        $("#WEB_SITE").removeClass("ng-untouched ng-valid");
        message += "Please enter Valid Web-Site.<br/>";
        isValid = false;
      }
    }


    if (formData.ADDRESS === null || formData.ADDRESS === "") {
      $("#ADDRESS").addClass("ng-touched ng-invalid validate-error");
      $("#ADDRESS").removeClass("ng-untouched ng-valid");
      message += "Please enter Address.<br/>";
      isValid = false;
    } else {
      $("#ADDRESS").addClass("ng-untouched ng-valid");
      $("#ADDRESS").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.POSTAL_CODE === null || formData.POSTAL_CODE === "") {
      $("#POSTAL_CODE").addClass("ng-touched ng-invalid validate-error");
      $("#POSTAL_CODE").removeClass("ng-untouched ng-valid");
      message += "Please enter Postal Code.<br/>";
      isValid = false;
    } else {
      $("#POSTAL_CODE").addClass("ng-untouched ng-valid");
      $("#POSTAL_CODE").removeClass("ng-touched ng-invalid validate-error");
    }

   

    if (formData.EMAIL === null || formData.EMAIL === "" || formData.EMAIL === undefined) {
      $("#EMAIL").addClass("ng-touched ng-invalid validate-error");
      $("#EMAIL").removeClass("ng-untouched ng-valid");
      message += "Please enter E-Mail.<br/>";
      isValid = false;
    } else {
      const mailformat = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      if (formData.EMAIL.match(mailformat)) {
        $("#EMAIL").addClass("ng-untouched ng-valid");
        $("#EMAIL").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#EMAIL").addClass("ng-touched ng-invalid validate-error");
        $("#EMAIL").removeClass("ng-untouched ng-valid");
        message += "Please enter Valid E-Mail.<br/>";
        isValid = false;
      }
    }
    if (formData.PHONE === null || formData.PHONE === "") {
      $("#PHONE").addClass("ng-touched ng-invalid validate-error");
      $("#PHONE").removeClass("ng-untouched ng-valid");
      message += "Please enter Phone Number.<br/>";
      isValid = false;
    } else {
      const phoneformat = /^[1-9]\d*$/;
      formData.PHONE = formData.PHONE + "";
      if (formData.PHONE.match(phoneformat)) {
        $("#PHONE").addClass("ng-untouched ng-valid");
        $("#PHONE").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#PHONE").addClass("ng-touched ng-invalid validate-error");
        $("#PHONE").removeClass("ng-untouched ng-valid");
        message += "Please enter Valid Phone Number.<br/>";
        isValid = false;
      }
    }

    if (formData.PHONE_EXT === null || formData.PHONE_EXT === "") {
      $("#PHONE_EXT").addClass("ng-touched ng-invalid validate-error");
      $("#PHONE_EXT").removeClass("ng-untouched ng-valid");
      message += "Please enter Phone Ext.<br/>";
      isValid = false;
    } else {
      const phoneformat = /^[1-9]\d*$/;
      formData.PHONE_EXT = formData.PHONE_EXT + "";
      if (formData.PHONE_EXT.match(phoneformat)) {
        $("#PHONE_EXT").addClass("ng-untouched ng-valid");
        $("#PHONE_EXT").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#PHONE_EXT").addClass("ng-touched ng-invalid validate-error");
        $("#PHONE_EXT").removeClass("ng-untouched ng-valid");
        message += "Please enter Valid Other Phone Ext.<br/>";
        isValid = false;
      }
    }

    if (formData.OTHER_PHONE === null || formData.OTHER_PHONE === "") {
      $("#OTHER_PHONE").addClass("ng-touched ng-invalid validate-error");
      $("#OTHER_PHONE").removeClass("ng-untouched ng-valid");
      message += "Please enter Other Phone Number.<br/>";
      isValid = false;
    } else {
      const phoneformat = /^[1-9]\d*$/;
      formData.OTHER_PHONE = formData.OTHER_PHONE + "";
      if (formData.OTHER_PHONE.match(phoneformat)) {
        $("#OTHER_PHONE").addClass("ng-untouched ng-valid");
        $("#OTHER_PHONE").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#OTHER_PHONE").addClass("ng-touched ng-invalid validate-error");
        $("#OTHER_PHONE").removeClass("ng-untouched ng-valid");
        message += "Please enter Valid Other Phone Number.<br/>";
        isValid = false;
      }
    }
    if (formData.OTHER_PHONE_EXT !== null && formData.OTHER_PHONE_EXT !== "") {
      $("#OTHER_PHONE_EXT").addClass("ng-untouched ng-valid");
      $("#OTHER_PHONE_EXT").removeClass("ng-touched ng-invalid validate-error");
    }
    else {
      $("#OTHER_PHONE_EXT").addClass("ng-untouched ng-valid");
      $("#OTHER_PHONE_EXT").removeClass("ng-touched ng-invalid validate-error");
      message += "Please enter Other Phone Ext.<br/>";
      isValid = false;
    }

    if (formData.OTHER_PHONE_EXT !== null && formData.OTHER_PHONE_EXT !== "") {
      const phoneformat = /^[1-9]\d*$/;
      formData.OTHER_PHONE_EXT = formData.OTHER_PHONE_EXT + "";
      if (formData.OTHER_PHONE_EXT.match(phoneformat)) {
        $("#OTHER_PHONE_EXT").addClass("ng-untouched ng-valid");
        $("#OTHER_PHONE_EXT").removeClass("ng-touched ng-invalid validate-error");
      }
      else {
        $("#OTHER_PHONE_EXT").addClass("ng-untouched ng-valid");
        $("#OTHER_PHONE_EXT").removeClass("ng-touched ng-invalid validate-error");
        message += "Please enter valid Other Phone Ext.<br/>";
        isValid = false;
      }
    }
    if (formData.FAX === null || formData.FAX === "") {
      $("#FAX").addClass("ng-touched ng-invalid validate-error");
      $("#FAX").removeClass("ng-untouched ng-valid");
      message += "Please enter Fax.<br/>";
      isValid = false;
    } else {
      $("#FAX").addClass("ng-untouched ng-valid");
      $("#FAX").removeClass("ng-touched ng-invalid validate-error");
    }

    if (formData.FAX_EXT === null || formData.FAX_EXT === "") {
      $("#FAX_EXT").addClass("ng-touched ng-invalid validate-error");
      $("#FAX_EXT").removeClass("ng-untouched ng-valid");
      message += "Please enter Fax Ext.<br/>";
      isValid = false;
    } else {
      $("#FAX_EXT").addClass("ng-untouched ng-valid");
      $("#FAX_EXT").removeClass("ng-touched ng-invalid validate-error");
    }

    if (!isValid)
      //this.modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: message } } });
    return isValid;
  }

}
